import { InjectionToken } from "@angular/core";

export const BASE_URI = new InjectionToken<string>("BASE_URI");
